import { useAppSelector } from '@/store/hooks';
import { getPublishedStatus } from '@/store/slices/project/selectors';
import { selectFavicon } from '@/store/slices/settings/selectors';
import { selectUserChannel } from '@/store/slices/user/selectors';
import getPrefixUrl from '@/utils/get-prefix-url';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';

interface ISiteSearchPreviewCardProps {
  name: string;
  description: string;
  blank?: boolean;
}

const SiteSearchPreviewCard = ({ name, description, blank = false }: ISiteSearchPreviewCardProps) => {
  const favicon = useAppSelector(selectFavicon);
  const publishedStatus = useAppSelector(getPublishedStatus);
  const channel = useAppSelector(selectUserChannel);

  const SiteSearchCardSkeleton = () => (
    <Container className="flex-column gap-24" height="100px" width="100%">
      <div className="flex gap-8">
        <Container width="28px" height="28px" background="var(--gray-100)" opacity={0.05} borderRadius="6px" />
        <div className="flex-column gap-4">
          <Container width="106px" height="8px" background="var(--gray-100)" opacity={0.05} borderRadius="2px" />
          <Container width="80px" height="6px" background="var(--gray-100)" opacity={0.05} borderRadius="2px" />
        </div>
      </div>
      <div className="flex-column gap-8">
        <Container width="186px" height="10px" background="var(--gray-100)" opacity={0.05} borderRadius="2px" />
        <Container width="407px" height="6px" background="var(--gray-100)" opacity={0.05} borderRadius="2px" />
        <Container width="255px" height="8px" background="var(--gray-100)" opacity={0.05} borderRadius="2px" />
      </div>
    </Container>
  );

  if (blank) {
    return <SiteSearchCardSkeleton />;
  }

  const baseURL = getPrefixUrl(channel?.url);
  const url = baseURL + '/' + publishedStatus?.url;

  return (
    <Container className="flex-column gap-24" width="100%">
      <div className="flex gap-8">
        <Container
          className="flex ai-center jc-center"
          width="32px"
          height="32px"
          background="var(--gray-900)"
          borderRadius="6px"
        >
          {favicon && <img src={favicon || ''} style={{ maxWidth: '16px', maxHeight: '16px' }} />}
        </Container>
        <div className="flex-column gap-4">
          <Text className="S2" color="var(--gray-300)">
            {name}
          </Text>
          <Text className="C1" color="var(--gray-300)">
            {url}
          </Text>
        </div>
      </div>
      <div className="flex-column gap-8">
        <Text className="S1" color="var(--secondary-blue-200)">
          {name}
        </Text>
        <Text className="C1" color="var(--gray-300)" clamp={3}>
          {description}
        </Text>
      </div>
    </Container>
  );
};

export default SiteSearchPreviewCard;
